// extracted by mini-css-extract-plugin
export default {"container":"ChatPage_container__ZQMza"};